import React from "react";
import { PartnerWrapper } from "./styles.Partners";

export const Partners: React.FC = () => {
  return (
    <PartnerWrapper>
      Research results from the 2021 #JournalismAI Collab Challenges in the
      London School of Economics and Political Science by{" "}
      <a target="_blank" href="https://www.sciencemediacenter.de/">
        Science Media Center Germany
      </a>{" "}
      and{" "}
      <a
        target="_blank"
        href="https://www.br.de/extra/ai-automation-lab/index.html"
        rel="noopener noreferrer"
      >
        BR AI + Automation Lab
      </a>{" "}
    </PartnerWrapper>
  );
};
